import { FieldsAPI } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { FDRStatus } from '@cibo/core'

const QUERY_KEY = 'orgStats'

export type UseRollupStatsParams = {
  orgId?: string
  programId?: string
}

export const useRollupStats = ({ orgId, programId }: UseRollupStatsParams) =>
  useQuery([QUERY_KEY, { orgId, programId }], () =>
    FieldsAPI.stats({
      orgId,
      fdrStats: [
        { programId, status: FDRStatus.eligibleForEnrollment },
        { programId, status: FDRStatus.enrolling },
        { programId, status: FDRStatus.enrolled },
      ],
    }).then(response => response?.data)
  )
